import React, { useEffect, useState } from 'react';
import { Icon, CloseIcon, ShoppingIcon, XLineIcon } from '@/components';
import { MessageType } from '@/layouts/shared';
import { ReplyMessageState } from '@/features/consults/chat/const';
import { fetchProductsByCodes } from '@/features/consults/chat/api';

interface ReplyPreviewProps {
  replyMessage: ReplyMessageState;
  onClear: () => void;
}

const ReplyPreview = ({ replyMessage, onClear }: ReplyPreviewProps) => {
  const { message, ownerName } = replyMessage;
  const [productImage, setProductImage] = useState<string | null>(null);

  const isProduct = message.type === MessageType.Product;
  const hasImages = message.images?.length > 0;

  useEffect(() => {
    setProductImage(null);
    if (!isProduct || !hasImages) return;
    fetchProductsByCodes({ product_code: message.images[0] })
      .then((res) => {
        if (Array.isArray(res.data) && res.data[0]?.image) {
          setProductImage(res.data[0].image);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message.images?.[0], isProduct]);

  const thumbnail = isProduct ? productImage : hasImages ? message.images[0] : null;
  const countLabel = isProduct
    ? `${message.images?.length} sản phẩm`
    : hasImages
    ? `${message.images.length} hình ảnh`
    : null;

  return (
    <div className="tw-flex tw-items-center tw-px-3 tw-py-2">
      <div className="tw-flex tw-items-center tw-w-full tw-px-3 tw-py-2 tw-bg-white tw-gap-2 tw-rounded-sm tw-border-l-[3px] tw-border-primary-main">
        {hasImages && (
          <div className="tw-flex-shrink-0 tw-h-8 tw-w-8">
            {isProduct && !thumbnail ? (
              <div className="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-black/10 tw-rounded-sm">
                <Icon className="tw-w-5 tw-h-5 tw-opacity-70" icon={<ShoppingIcon />} />
              </div>
            ) : (
              // eslint-disable-next-line @next/next/no-img-element
              <img src={thumbnail!} alt="" className="tw-h-full tw-w-full tw-object-cover tw-rounded-sm" />
            )}
          </div>
        )}
        <div className="tw-min-w-0 tw-flex-1">
          <div className="tw-text-xs tw-font-semibold tw-leading-tight tw-truncate">Trả lời {ownerName}</div>
          {countLabel ? (
            <div className="tw-text-[11px] tw-leading-tight tw-truncate">{countLabel}</div>
          ) : (
            <div className="tw-text-[11px] tw-leading-tight tw-truncate">{message.content}</div>
          )}
        </div>
        <button type="button" onClick={onClear} className="tw-flex-shrink-0 tw-p-1">
          <Icon className="!tw-w-3 !tw-h-3" icon={<XLineIcon />} />
        </button>
      </div>
    </div>
  );
};

export default ReplyPreview;
